import {ADD_CART, GET_CART} from '../actions/types'

const chartItems = (state = {}, action) => {

    switch (action.type) {
        case ADD_CART:
            return {...state, ...action.payload};
        case GET_CART:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

export default chartItems;
